module.exports = __webpack_public_path__ + "media/08-amph-norepinephrine.163b7944.mp4";